import React, { useEffect } from "react";
import "./buvStyle.css";
import { useTranslation } from "react-i18next";

// import style from "./dashboard.module.scss";
// import wallet from "../../../assets/images/dashboard/wallet-icon.png";
// import { useHistory } from "react-router-dom";
// import { useTranslation } from "react-i18next";
// import { useSelector } from "react-redux";
// import { CurrencyDecimalFormat } from "../../helper";
// import commission from "../../../assets/images/dashboard/commision-earned.png";
// import payment from "../../../assets/images/dashboard/paymnt-rlsd.png";
// import pending from "../../../assets/images/dashboard/pending-5-861794.png";
// import UserStore from "../../../store/UserStore";
// import TilesFilter from "./TilesFilter";

const BUVitems = React.memo((props) => {
  

  // if (!props.remainingBUV) {
  //     return <div>Loading...</div>;
  // }
  // if (!props.accumulatedBuv) {
  //     return <div>Loading...</div>;
  // }

  if (props.remainingBUV) {
    return (
      <>
        <div>
          <div>
            <div>
              <div>
                {/* {t("Remaining BUV")} */}
                <div style={{ fontWeight: "bold" }}>Remaining BUV</div>
              </div>
              <div
                className="remainingBuv"
                style={{
                  fontSize: "16px",
                  display: "flex",
                  width: "100%",
                  height: "190px",
                  justifyContent: "space-around",
                  borderRight: "1px solid #ced4da",
                  marginTop: "30px",
                  paddingTop: "40px",
                  paddingBottom: "10px",
                }}
              >
                {props.remainingBUV.map((items) => {
                  return (
                    <div style={{ textAlign: "center" }}>
                      <div>
                        <h6
                          style={{
                            fontWeight: "900",
                            fontSize: "1.5rem",
                            color: "#000",
                          }}
                        >
                          {items.head}
                        </h6>
                      </div>
                      <div style={{ fontSize: "11px" }}>{items.title}</div>
                    </div>
                  );
                })}
              </div>
            </div>
          </div>
        </div>

        <div>
          <div>
            <div>
              <div>
                {/* {t("Accumulated Buv")} */}
                <div style={{ fontWeight: "bold" }}>Accumulated BUV</div>
              </div>
              <div
                className="accumalted_style"
                style={{
                  fontSize: "16px",
                  display: "flex",
                  width: "100%",
                  justifyContent: "space-around",
                  marginTop: "30px",
                  paddingTop: "40px",
                  paddingBottom: "10px",
                  paddingLeft: "20px",
                }}
              >
                {props.accumulatedBuv.map((items) => {
                  return (
                    <div style={{ textAlign: "center" }}>
                      <div>
                        <h6
                          style={{
                            fontWeight: "900",
                            fontSize: "1.5rem",
                            color: "#000",
                          }}
                        >
                          {items.head}
                        </h6>
                      </div>
                      <div style={{ fontSize: "10px" }}>{items.title}</div>
                    </div>
                  );
                })}
              </div>
            </div>
          </div>
        </div>
      </>
    );
  }
});
export default BUVitems;
